import { Component, OnInit } from '@angular/core';
import { CreateSectorComponent } from './create-sector/create-sector.component';
import { MatDialog} from '@angular/material/dialog';
import { SectorService } from './sector.service';
import { DtoSector } from '../../models/sector.model';
import { MatDialogCloseEvent, Role } from '../../const';
import { EditSectorComponent } from './edit-sector/edit-sector.component';
import { Router } from '@angular/router';
import { SharedService } from '../../shared/services/shared.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { MatAccountService } from '../mat-account/mat-account.service';
import { ClientAccountDetails, Pagination } from '../../models/mat-account.model';

@Component({
  selector: 'app-sector',
  templateUrl: './sector.component.html'
})
export class SectorComponent implements OnInit {
  
  sectors: DtoSector[] = [];
  userRole: string[] = [];
  roles = Role;
  roleName: string[] = [];
  userEmail: string = "";
  userId: number = 0;
  matAccountList: ClientAccountDetails[] = [];
  loading:boolean=true;

  constructor(
    public dialog: MatDialog,
    public sectorService: SectorService,
    private router: Router,
    private sharedService: SharedService,
    private toasterService: ToastrService,
    private matAccountService: MatAccountService
  ) { }

  ngOnInit(): void {
    const navigation = this.router.getCurrentNavigation();
    const state = history.state;
    if(state){
      this.userId = state.userId;
    }
    
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
    this.userEmail = sessionStorage.getItem('user_email')!;
    this.userRole?.forEach(element => {
      this.roleName.push(this.getRoleNameByValue(Role, element)!);
    });

    this.getSectors();
  }

  setSector(sector: DtoSector){
    this.sharedService.setLocalStorageValueOfSector(sector.sectorId.toString());
    if(Number(sessionStorage.getItem('sector')) == 1){
      let pagination: Pagination = {
        searchTerm: "",
        pageOffset: 0,
        pageSize: 0,
        sortColumn: "",
        sortDirection: "",
        userRole: this.userRole,
        isActive: true
      }
      this.matAccountService.getMatAccount(sector.sectorId, pagination).subscribe((response: ClientAccountDetails[] | any) => {
        this.matAccountList = response;
        this.router.navigate(['/userCenter']);
      }, (error: HttpErrorResponse) => {
        if(error.error){
          this.toasterService.error(error.error, "Error");
        }
      })
    }
    else{
      this.router.navigate(['/accountAdminCenter']);
    }
  }

  getRoleNameByValue<T extends { [index: string]: string }>(
    enumObj: T,
    value: string
  ): string | undefined {
    const keys = Object.keys(enumObj).filter((x) => enumObj[x] === value);
    return keys.length > 0 ? keys[0] : undefined;
  }

  getSectors(){
    this.loading=true;
    this.sectorService.getSectors(this.userId).subscribe((response: DtoSector[] | any) => {
      this.sectors = response;
      this.loading=false;
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  createSector() {
    this.dialog.open(CreateSectorComponent, {
      width: '565px'
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        this.getSectors();
      }
    });;
  }

  editSector(sector: DtoSector){
    this.dialog.open(EditSectorComponent, {
      width: '565px',
      data: sector
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        this.getSectors();
      }
    });
  } 
}
